export class DetectorSummary {
    'detectorType';
    'conclusion';
    'counts';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "detectorType",
            "baseName": "detectorType",
            "type": "DetectorSummaryDetectorTypeEnum",
            "format": ""
        },
        {
            "name": "conclusion",
            "baseName": "conclusion",
            "type": "DetectorSummaryConclusionEnum",
            "format": ""
        },
        {
            "name": "counts",
            "baseName": "counts",
            "type": "Array<FindingCountEntry>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DetectorSummary.attributeTypeMap;
    }
    constructor() {
    }
}
export var DetectorSummaryDetectorTypeEnum;
(function (DetectorSummaryDetectorTypeEnum) {
    DetectorSummaryDetectorTypeEnum["Malware"] = "MALWARE";
    DetectorSummaryDetectorTypeEnum["RansomwareBehavior"] = "RANSOMWARE_BEHAVIOR";
    DetectorSummaryDetectorTypeEnum["DataAnomaly"] = "DATA_ANOMALY";
})(DetectorSummaryDetectorTypeEnum || (DetectorSummaryDetectorTypeEnum = {}));
export var DetectorSummaryConclusionEnum;
(function (DetectorSummaryConclusionEnum) {
    DetectorSummaryConclusionEnum["Clean"] = "CLEAN";
    DetectorSummaryConclusionEnum["HighChanceForRansomware"] = "HIGH_CHANCE_FOR_RANSOMWARE";
    DetectorSummaryConclusionEnum["DataAnomalyDetected"] = "DATA_ANOMALY_DETECTED";
    DetectorSummaryConclusionEnum["MalwareDetected"] = "MALWARE_DETECTED";
})(DetectorSummaryConclusionEnum || (DetectorSummaryConclusionEnum = {}));
